import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { BillingFrequency } from '@delmonicos/shared-sdk/libs/cpms/src/libs/shared/src/enums/billing-frequency.enum';
import { useTranslation } from 'react-i18next';

interface EmspBoEmspUserBillingFrequencyFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const EmspBoEmspUserBillingFrequencyFilterController = ({
  onChange,
  selectedItemIds,
}: EmspBoEmspUserBillingFrequencyFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const billingFrequencyList = Object.values(BillingFrequency).map(
    (billingFrequency) => ({
      key: billingFrequency,
      value: t(`delmonicos-shared-sdk.billing-frequency.${billingFrequency}`),
    }),
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="calendar"
        text={t('delmonicos-shared-sdk.outputs-emsp-user.billing-frequency')}
      />
      <FilterToggle
        initialSelectedItemIds={selectedItemIds}
        items={billingFrequencyList}
        onChange={onChange}
      />
    </Stack>
  );
};
